import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppComponent from '../../components/App/AppComponent';
import requestLogout from '../../features/actions/requestLogout';
import requestUserData from '../../features/actions/requestUserData';
import NotificationContainer from '../Notification/NotificationContainer';

export default function AppContainer() {
    const dispatch = useDispatch();

    const userData = useSelector((state) => state.currentUser);

    function onLogoutRequested() {
        dispatch(requestLogout());
    }

    useEffect(() => {
        dispatch(requestUserData());
    }, [dispatch]);

    return (
        <>
            {userData && <AppComponent authenticated={!!userData.id} onLogoutRequested={onLogoutRequested} />}
            <NotificationContainer />
        </>
    );
}
